import React from 'react';

import { SelectOptionType } from '@models/common';
import { Select } from 'antd';
import { LabeledValue } from 'antd/lib/select';

import './CustomSelect.scss';

function CustomSelect({
  value,
  mode,
  disabled,
  showSearch,
  allowClear,
  optionFilterProp,
  labelInValue,
  placeholder = '',
  options,
  optionRender,
  onChange,
  onSearch,
  style,
}: // isLoading,
// onFocus,
{
  value?: string | string[] | number | number[] | LabeledValue | LabeledValue[];
  mode?: 'multiple' | 'tags';
  disabled?: boolean;
  showSearch?: boolean;
  allowClear?: boolean;
  optionFilterProp?: string;
  labelInValue?: boolean;
  placeholder: string;
  options: SelectOptionType[];
  optionRender?: (option: any, info: { index: number }) => React.ReactNode;
  onChange?: (
    value: any,
    option: SelectOptionType | SelectOptionType[],
  ) => void;
  onSearch?: (value: string) => void;
  style?: Record<string, string>;
  // isLoading?: boolean;
  // onFocus?: React.FocusEventHandler<HTMLElement> | undefined;
}) {
  function filterOption(
    input: string,
    option?: { label: string; value: string },
  ) {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  }

  return (
    <Select
      value={value}
      mode={mode}
      disabled={disabled}
      showSearch={showSearch}
      allowClear={allowClear}
      optionFilterProp={optionFilterProp}
      labelInValue={labelInValue}
      placeholder={placeholder}
      options={options}
      optionRender={optionRender}
      onChange={onChange}
      onSearch={onSearch}
      listHeight={40 * 5}
      className="CustomSelect"
      style={style}
      filterOption={(val, option) =>
        filterOption(val, {
          label: option?.label || '',
          value: option?.value.toString() || '',
        })
      }
      // notFoundContent={
      //   isLoading ? (
      //     <div style={{ padding: '0.5rem', textAlign: 'center' }}>
      //       <Spin />
      //     </div>
      //   ) : undefined
      // }
      // onFocus={onFocus}
    />
  );
}

export default CustomSelect;
